import { buySubscriptionSuccess } from '../../../../../shared/redux/reducers';
import { publishOffer } from '../../../../../shared/redux/reducers';
import { selectActiveRecommendedPackage } from '../../../../../shared/selectors/publishTerms';
import './PackageBuyResultModal.css';

export function PackageBuyResultModalController(
  $scope, $uibModalInstance, settings, placingTermsApi, popupService, $rootScope,
  deviceService, servicePackagesService, publishTermsService, store,
) {
  'ngInject';

  const state = store.getState();

  let { selectedPeriod } = placingTermsApi.selected.option;

  if (publishTermsService.isNewPublishTermsEnabled()) {
    selectedPeriod = selectActiveRecommendedPackage(state);
  }

  const { id, count, durationInDays, services, polygonIds } = selectedPeriod;

  $scope.isMobile = deviceService.isMobile;
  $scope.state = 'loading';
  $scope.count = count - 1;
  $scope.durationInDays = durationInDays;
  $scope.handsIcon = require('./images/hands.png');

  const parameters = {
    packageId: id,
    autoProlong: settings.autoProlong,
    polygonIds,
  };

  servicePackagesService.buyPackage(parameters).then(({ code, message }) => {
    $scope.state = code;
    $scope.message = message;

    if (code === 'Ok') {
      $rootScope.shouldSkipPublishModals = true;

      if (publishTermsService.isNewPublishTermsEnabled()) {
        store.dispatch(buySubscriptionSuccess());
      } else {
        const serviceType = services.join('+');

        const service = placingTermsApi.getOptionById(serviceType);

        if (service) {
          placingTermsApi.selectOption(service);
          placingTermsApi.updateTerms();
        }
      }
    }
  });

  $scope.publishOffer = () => {
    $uibModalInstance.close();

    $uibModalInstance.closed.then(() => {
      if (publishTermsService.isNewPublishTermsEnabled()) {
        store.dispatch(publishOffer({ isPremoderationSkip: false }));
      } else {
        $rootScope.$broadcast('simulateSubmitClick');
      }
    });
  };

  $scope.refillBalance = () => {
    $uibModalInstance.close();

    if (deviceService.isMobile) {
      $uibModalInstance.closed.then(() => {
        popupService.openPopup('payByCard', { options: { source: 'placing-options' } });
      });
    } else {
      popupService.openPopup('payByCard', { options: { source: 'placing-options' } });
    }
  };

  $scope.$on('modal.closing', (e, res, wasClosed) => {
    // Не даём закрыть модалку, если идёт запрос
    if ($scope.state === 'loading') {
      e.preventDefault();
    }

    // Всегда отправляем state при закрытии модалки
    if (res !== $scope.state) {
      e.preventDefault();

      if (wasClosed) {
        $uibModalInstance.close($scope.state);
      } else {
        $uibModalInstance.dismiss($scope.state);
      }
    }
  });
}
